module.exports = __webpack_public_path__ + "images/androidLogo-d20768f8fddea9324ed0a24d5f041a28.png";